import { Menu, type MenuSelectGroupProps } from "@overmap-ai/blocks"
import { OrganizationAccessLevel, ORGANIZATION_ACCESS_LEVELS } from "@overmap-ai/common"
import { memo } from "react"

import { organizationAccessLevelData } from "../../mappings/organizations"
import { SelectItemTemplate } from "../MenuGroups/constants"

export type OrganizationAccessLevelSelectGroupProps = MenuSelectGroupProps<OrganizationAccessLevel>

export const OrganizationAccessLevelSelectGroup = memo<OrganizationAccessLevelSelectGroupProps>((props) => {
	const { ref, ...rest } = props

	return (
		<Menu.SelectGroup<OrganizationAccessLevel> ref={ref} {...rest}>
			{ORGANIZATION_ACCESS_LEVELS.map((organizationAccessLevel) => (
				<SelectItemTemplate<OrganizationAccessLevel>
					key={organizationAccessLevel}
					value={organizationAccessLevel}
				>
					{organizationAccessLevelData[organizationAccessLevel].label}
				</SelectItemTemplate>
			))}
		</Menu.SelectGroup>
	)
})
OrganizationAccessLevelSelectGroup.displayName = "OrganizationAccessLevelSelectGroup"
